import { createSlice } from "@reduxjs/toolkit";
import { fetchWarehouseDispatch } from "./thunk";

interface ReadyForDispatchState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: ReadyForDispatchState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const WarehouseDispatchSlice = createSlice({
  name: "WarehouseDispatchSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWarehouseDispatch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehouseDispatch.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchWarehouseDispatch.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message ||
          "Failed to fetch Dispatch List";
      });
  },
});

export default WarehouseDispatchSlice.reducer;
